/* eslint-disable camelcase */
/**
 * @author Fernando Ruano
 * @file index.js
 * @description Country User Role Services
 */

// Core
import endpoints from '@nephro/config/endpoints';
import { externalConnector } from '@nephro/core/connector';

// Endpoints
const { countryUserRole: countryUserRoleEndpoints } = endpoints;

export class CountryUserRoleService {
  constructor(http) {
    this.http = http;
  }

  /**
   * Create CountryUserRole
   * @param { Object } country - Country data.
   * @param { Object } profile - Profile data.
   * @param { Object } role - Role data.
   * @param { Object } user - User data.
   * @return { promise } - The countryUserRole promise object.
   */
  createCountryUserRole = async (country, profile, role, user, id_clinic) => {
    const body = { country, profile, role, user, id_clinic };
    const url = countryUserRoleEndpoints.base;
    return this.http.post(url, body);
  };

  /**
   * Get CountryUserRoles list with pagination
   * @param { string } paged - Activate pagination.
   * @param { string } limit - Items per page.
   * @param { string } page - Current page.
   * @return { Object } - Get countryUserRoles list.
   */
  getCountryUserRoles = async (paged, limit, page) => {
    const queryParam = `?limit=${limit}&page=${page}&paged=${paged}`;
    let url = countryUserRoleEndpoints.base;
    if (paged) {
      url = `${url}${queryParam}`;
    }
    return this.http.get(url);
  };

  /**
   * Get CountryUserRole info by id
   * @param { string } id - CountryUserRole id.
   * @return { Object } - Get countryUserRoles list.
   */
  getCountryUserRoleById = async (id) => {
    const url = `${countryUserRoleEndpoints.base}/${id}`;
    return this.http.get(url);
  };

  /**
   * Delete CountryUserRole by id
   * @param { string } id - CountryUserRole id.
   * @return { Object } - Get countryUserRoles list.
   */
  deleteCountryUserRoleById = async (id) => {
    const url = `${countryUserRoleEndpoints.base}/${id}`;
    return this.http.delete(url);
  };

  /**
   * Update CountryUserRole
   * @param { Object } country - Country data.
   * @param { Object } profile - Profile data.
   * @param { Object } role - Role data.
   * @param { Object } user - User data.
   * @param { string } id - CountryUserRole id.
   * @return { promise } - The CountryUserRole promise object.
   */
  updateCountryUserRole = async (
    country,
    profile,
    role,
    user,
    id_clinic,
    id
  ) => {
    const body = { country, profile, role, user, id_clinic };
    const url = `${countryUserRoleEndpoints.base}/${id}`;
    return this.http.update(url, body, {}, 'put');
  };
}

export default new CountryUserRoleService(externalConnector);
